export default (...args: Parameters<typeof console.log>) => {
  if (process.env.VUE_APP_ENV !== 'pro') {
    // eslint-disable-next-line no-console
    console.info('[卡券商城]', ...args);
  }
};
